/**
 * <TutorBillingStep> — « Indique tes informations de facturation » (organism).
 *
 * L'interrupteur « J'ai déjà le statut auto-entrepreneur », qui fait paraître le numéro SIRET. Plus
 * d'IBAN (Wajih, 03/11) : le versement passe par le compte Stripe du tuteur, où il donne son IBAN,
 * et l'étape le dit en une ligne. Les erreurs arrivent en props, sous leur champ.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Switch } from "../../atoms/Switch"
import { TextInput } from "../../atoms/TextInput"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../../molecules/Card"

export type TutorBillingStepProps = {
    isAutoEntrepreneur: boolean
    onToggleAutoEntrepreneur: (next: boolean) => void
    siret: string
    onChangeSiret: (value: string) => void
    siretError?: string
    disabled?: boolean
    testID?: string
}

const TEXTS = {
    status: "J'ai déjà le statut auto-entrepreneur",
    siret: "Numéro SIRET",
    payout: "Tes cours te sont versés par Stripe : ton IBAN, tu le donnes à Stripe (« Enregistre ton compte Stripe », sur ton accueil).",
}

export function TutorBillingStep(props: TutorBillingStepProps) {
    const { isAutoEntrepreneur, onToggleAutoEntrepreneur, siret, onChangeSiret, siretError, disabled, testID } = props

    return (
        <Stack gap="4" testID={testID}>
            <Card p="4">
                <Stack gap="3">
                    <Switch
                        checked={isAutoEntrepreneur}
                        onChange={onToggleAutoEntrepreneur}
                        label={TEXTS.status}
                        disabled={disabled}
                    />
                    {isAutoEntrepreneur && (
                        <TextInput
                            label={TEXTS.siret}
                            placeholder={TEXTS.siret}
                            value={siret}
                            onChangeText={onChangeSiret}
                            error={siretError}
                            keyboardType="number-pad"
                            disabled={disabled}
                        />
                    )}
                </Stack>
            </Card>
            <Text size="text-md" color="text-muted">
                {TEXTS.payout}
            </Text>
        </Stack>
    )
}
